import React, { useContext, useState } from 'react'
import PropTypes from 'prop-types'
import {
    ExpansionPanel,
    ExpansionPanelSummary,
    ExpansionPanelDetails,
    Grid,
    Typography
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import PriceTag from '../PriceTag/PriceTag'
import { CalculatorContext } from '../Context/CalculatorContext'
import BlockTitle from './BlockTitle'

const useStyles = makeStyles((theme) => ({
    root: {
        marginBottom: theme.spacing(2)
    },
    expansionPanel: {
        backgroundColor: theme.palette.background.paper,
        margin: 0,
        padding: 0
    },
    suffixInput: {
        border: 'none',
        backgroundColor: 'transparent',
        color: theme.palette.text.primary,
        fontSize: theme.typography.h4.fontSize
    },
    editIcon: {
        marginLeft: theme.spacing(1)
    },
    costLabel: {
        display: 'inline',
        fontStyle: 'italic',
        marginLeft: theme.spacing(1)
    }
}))

const Block = ({ title, cost, suffix, setSuffix, startOpen, children }) => {
    const [isOpen, setIsOpen] = useState(startOpen)
    const [isEditingTitle, setIsEditingTitle] = useState(false)
    const { currency } = useContext(CalculatorContext)
    const classes = useStyles()

    const handleSetEditing = (event) => {
        event.stopPropagation()
        setIsEditingTitle((prev) => !prev)
    }

    const renderTitle = () => {
        if (!setSuffix) {
            return title
        }
        return `${title} ${!suffix ? ' for...' : ' - '}`
    }

    return (
        <div className={classes.root}>
            <ExpansionPanel
                className={classes.expansionPanel}
                expanded={isOpen}
                onChange={() => setIsOpen((prev) => !prev)}
            >
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon fontSize={'large'} />}
                    aria-controls={`${title}-content`}
                    id={`${title}-header`}
                >
                    <Grid container spacing={0}>
                        <Grid item xs={12}>
                            <BlockTitle
                                {...{
                                    title: renderTitle(),
                                    suffix,
                                    setSuffix,
                                    isEditing: isEditingTitle,
                                    setEditing: handleSetEditing
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <div>
                                <Typography
                                    variant="h5"
                                    color="textSecondary"
                                    className={classes.costLabel}
                                >
                                    Estimated cost:
                                </Typography>
                                <PriceTag total={cost} currency={currency} />
                            </div>
                        </Grid>
                    </Grid>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <Grid container spacing={0}>
                        <Grid item xs={12}>
                            {children}
                        </Grid>
                    </Grid>
                </ExpansionPanelDetails>
            </ExpansionPanel>
        </div>
    )
}

Block.defaultProps = {
    startOpen: false
}

Block.propTypes = {
    title: PropTypes.string.isRequired,
    startOpen: PropTypes.bool,
    cost: PropTypes.number.isRequired,
    suffix: PropTypes.string,
    setSuffix: PropTypes.func
}

export default Block
